<template>
  <b-toast id="session-alert-toast" @hidden="closeSessionAlert">
    <template #toast-title>
      <div class="d-flex flex-grow-1 align-items-baseline mr-2">
        <strong class="mr-2">
          <font-awesome-icon icon="exclamation-circle" />
          {{ $t('MESSAGE.sessionAlertTitle') }}
        </strong>
      </div>
    </template>
    {{ $t('MESSAGE.sessionAlert', [this.$setting.SESSION_ALERT_TIME]) }}
  </b-toast>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'SystemToast',
  computed: {
    toast () {
      return this.$store.state.toast
    },
    count () {
      return this.$store.getters['toast/getCount']
    }
  },
  methods: {
    showToast (toast) {
      // アイコンタイトルのデフォルト設定
      let defaultTitle = this.$t('TOAST.default.success')
      let titleIcon = 'check-circle'
      let defaultSubtitle = ''
      if (toast.variant === 'danger') {
        titleIcon = 'exclamation-circle'
        defaultTitle = this.$t('TOAST.default.danger')
      } else if (toast.variant === 'info') {
        titleIcon = 'info-circle'
        defaultTitle = this.$t('TOAST.default.info')
      }
      if (toast.title) defaultTitle = toast.title

      const h = this.$createElement
      // Create the message
      const vNodesMsg = h(
        'p',
        { class: ['text-center', 'mb-0'] },
        [
          toast.message
        ]
      )
      // Create the title
      const vNodesTitle = h(
        'div',
        { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
        [
          h('strong', { class: 'mr-2' },
            [
              h(FontAwesomeIcon, { props: { icon: titleIcon } }),
              ' ' + defaultTitle
            ]
          ),
          h('small', { class: 'ml-auto text-italics' }, defaultSubtitle)
        ]
      )
      const noAutoHide = (toast.timeout === 0)
      const autoHideDelay = (toast.timeout === 0) ? -1 : toast.timeout

      // Toast発行
      this.$bvToast.toast([vNodesMsg], {
        title: [vNodesTitle],
        solid: true,
        variant: toast.variant,
        autoHideDelay: autoHideDelay,
        noAutoHide: noAutoHide
      })
    },
    errorToast: (title, err) => {
      this.$store.dispatch('toast/showToast', {
        title: title,
        message: err,
        variant: 'danger',
        timeout: 0
      })
    },
    sessionAlert: () => {
      this.$bvToast.show('session-alert-toast')
    },
    closeSessionAlert: () => {
      console.log('closeSessionAlert')
    }
  },
  watch: {
    count (val, old) {
      // store.state.toast.countを監視しカウントアップされたらToastを表示
      if (this.toast.title === 'sessionAlert') {
        this.sessionAlert()
      } else {
        this.showToast(this.toast)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SystemToasts.vue